@if (activeStatus) {
  <div>{{ activeStatus.name }}</div>
} @else {
  -
}
